import React, { Component }        from 'react';
import { withRouter }              from 'react-router';
import { connect as reduxConnect } from 'react-redux';
import Splash                      from './Splash';
import ConnectForm                 from './ConnectForm';
import ChatCards                   from './ChatCards';

class UserLanding extends Component {

  render() {   
    return (
      <div>
        <ChatCards />
        <ConnectForm />
        <Splash />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default withRouter(reduxConnect(mapStateToProps, mapDispatchToProps)(UserLanding));
